import {
  StyleSheet,
  View,
  Text,
  Modal,
  TouchableOpacity,
  Image,
  ScrollView,
  Platform,
} from 'react-native';

const genderStyles = {
  BOY: { color: '#00BFFF', backgroundColor: '#00BFFF66', label: 'Boy' },
  GIRL: { color: '#EE3897', backgroundColor: '#EE389766', label: 'Girl' },
};

export default function KidInfoModal({ kid, visible, setVisible }) {
  if (!kid) return null;

  const gender = genderStyles[kid.gender] || genderStyles.BOY;

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={visible}
      onRequestClose={() => setVisible(false)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>

          <TouchableOpacity style={styles.closeBtn} onPress={() => setVisible(false)}>
            <Text style={styles.closeBtnText}>✕</Text>
          </TouchableOpacity>

          <ScrollView
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
          >
            <Image
              style={styles.avatar}
              source={
                kid.profilePic
                  ? { uri: kid.profilePic }
                  : require('./assets/AddKidPic.png')
              }
            />
            <Text style={styles.name}>{kid.name}</Text>

            <View style={styles.badgeRow}>
              <View style={styles.ageBadge}>
                <Text style={styles.ageBadgeText}>{kid.age} years</Text>
              </View>
              <View style={[styles.genderBadge, { backgroundColor: gender.backgroundColor }]}>
                <Text style={[styles.genderBadgeText, { color: gender.color }]}>
                  {gender.label}
                </Text>
              </View>
            </View>

            <View style={styles.detailsCard}>
              <View style={styles.detailRow}>
                <Text style={styles.label}>EMERGENCY NUMBER</Text>
                <Text style={styles.value}>{kid.emergencyPhone || '-'}</Text>
              </View>

              <View style={styles.detailRow}>
                <Text style={styles.label}>ALLERGY</Text>
                <Text style={styles.value}>{kid.allergy || '-'}</Text>
              </View>

              <View style={[styles.detailRow, styles.detailRowLast]}>
                <Text style={styles.label}>HEALTH ISSUE</Text>
                <Text style={styles.value}>{kid.healthIssue || '-'}</Text>
              </View>
            </View>
          </ScrollView>

        </View>
      </View>
    </Modal>
  );
}

const fontFamily = Platform.OS === 'android' ? 'FacebookSansRegular' : 'Facebook Sans';
const fontFamilyBold = Platform.OS === 'android' ? 'FacebookSansBold' : 'Facebook Sans';

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  modalView: {
    margin: 20,
    backgroundColor: '#fff',
    borderRadius: 16,
    width: '90%',
    maxWidth: 1000,
    maxHeight: '90%',
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 5,
  },

  closeBtn: {
    position: 'absolute',
    top: 12,
    right: 14,
    zIndex: 100,
    padding: 6,
  },
  closeBtnText: {
    fontSize: 18,
    color: '#888',
    fontWeight: 'bold',
  },

  scrollContent: {
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingTop: 44,
    paddingBottom: 24,
  },
  avatar: {
    width: 90,
    height: 90,
    borderRadius: 45,
    borderWidth: 3,
    borderColor: '#A6CE39',
    marginBottom: 12,
  },
  name: {
    fontSize: 20,
    color: '#1A1A1A',
    fontFamily: fontFamilyBold,
    fontStyle: 'normal',
    marginBottom: 10,
  },

  badgeRow: {
    flexDirection: 'row',
    marginBottom: 22,
  },
  ageBadge: {
    backgroundColor: '#A6CE3933',
    paddingHorizontal: 14,
    paddingVertical: 5,
    borderRadius: 20,
    marginRight: 8,
  },
  ageBadgeText: {
    color: '#556B2F',
    fontSize: 13,
    fontFamily: fontFamilyBold,
    fontStyle: 'normal',
  },
  genderBadge: {
    paddingHorizontal: 14,
    paddingVertical: 5,
    borderRadius: 20,
  },
  genderBadgeText: {
    fontSize: 13,
    fontFamily: fontFamilyBold,
    fontStyle: 'normal',
  },

  detailsCard: {
    width: '100%',
    backgroundColor: '#F7F9FA',
    borderRadius: 12,
    paddingHorizontal: 16,
  },
  detailRow: {
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E5EA',
  },
  detailRowLast: {
    borderBottomWidth: 0,
  },
  label: {
    fontSize: 11,
    color: '#8E8E93',
    letterSpacing: 0.8,
    marginBottom: 4,
    fontFamily,
    fontStyle: 'normal',
  },
  value: {
    fontSize: 15,
    color: '#1A1A1A',
    fontFamily,
    fontStyle: 'normal',
  },
});
